import { ParsedUrlQuery } from 'querystring'
import { EMPTY_LIST_OPTION } from '@/constants'
import EmptyList from '@/components/EmptyList'

interface Props {
  query: ParsedUrlQuery
}

const EmptyInventoryFilterResult = ({ query }: Props) => {
  let type: EMPTY_LIST_OPTION = 'noResults'
  let path: string = undefined

  if (query.show_only_listings) {
    type = 'noListings'
  }
  if (query.exclude_non_arcade) {
    path = 'pages/inventory/'
    if (query.type === 'Unopened') {
      type = 'ArcadeUnopened'
    } else {
      type = 'ArcadeItems'
    }
  }

  return <EmptyList type={type} imagePath={path} />
}

export default EmptyInventoryFilterResult
